import React, { useEffect, createElement } from 'react';
interface GoogleTagManagerProps {
  gtmId: string;
}
export function GoogleTagManager({
  gtmId
}: GoogleTagManagerProps) {
  useEffect(() => {
    // Add GTM script to head
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.insertBefore(scriptElement, document.head.firstChild);
    // Add noscript fallback to body
    const noscriptElement = document.createElement('noscript');
    const iframeElement = document.createElement('iframe');
    iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframeElement.height = '0';
    iframeElement.width = '0';
    iframeElement.style.display = 'none';
    iframeElement.style.visibility = 'hidden';
    noscriptElement.appendChild(iframeElement);
    document.body.insertBefore(noscriptElement, document.body.firstChild);
    // Cleanup function
    return () => {
      document.head.removeChild(scriptElement);
      document.body.removeChild(noscriptElement);
    };
  }, [gtmId]);
  return null;
}